import { render } from "./NotFound.vue?vue&type=template&id=cc71cd8e&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=cc71cd8e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc71cd8e"]])

export default __exports__